import React from 'react';
import critic1 from '../assets/critics/critic-1.jpeg'
import critic2 from '../assets/critics/critic-2.jpg'

const Critics = () => {
  // Array to store testimonials data
  const testimonials = [
    {
      image: critic1, 
      quote: "Μετά από δυσκολία εύρεσης του νυφικού που είχα φανταστεί πήγα στη Τζενη υστερα από παρότρυνση της κουμπαράς μου. Η Τζενη όχι απλά έφτιαξε το νυφικό που της έδειξα, αλλά ξεπέρασε τις προσδοκίες μου. Το καλύτερο boho chic νυφικό!!! Καθώς διέμενα στη Λερο, η Τζενη κατάφερε σε λίγα ραντεβού να φτιάξει το νυφικό και να προσαρμόσει τις συναντήσεις στο πρόγραμμά μου. Παράλληλα προσαρμόσε τις διαστάσεις του στην εγκυμοσύνη που προέκυψε. Το νυφικό τους ενθουσίασε όλους! Πρόκειται για έναν γλυκύτατο άνθρωπο με θετική αύρα και γνώση του αντικειμένου με τον οποίο χαίρεσαι να δημιουργείς κάτι τόσο σημαντικό για την ημέρα του γαμου! Νιώθω πολύ τυχερή που τη γνώρισα!",
      name: "Ραφαέλα",
    },
    {
      image: critic2,
      quote: "Το γλυκό μου Τζενάκι! Όλη η διαδικασία για τη δημιουργία του νυφικού μου ήταν όνειρο!!! Περίμενα την κάθε πρόβα με μεγάλη ανυπομονησία και την απολάμβανα με το παραπάνω. Τζένη μου γλυκιά σε ευχαριστώ τόσο πολύ! Πάντα να δημιουργείς και να μεγαλουργείς!",
      name: "Ειρήνη",
    },

  ];

  return (
    <div className="py-6">
      <h2 className="text-2xl text-center font-thin font-serif opacity-50 mb-5">ΔΗΜΙΟΥΡΓΙΕΣ ΜΑΣ</h2>

      {/* Container for testimonials */}
      <div className="flex flex-col md:flex-row gap-8 md:gap-4 max-w-8xl mx-auto  ">
        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            className="flex flex-col md:flex-row md:w-1/2 bg-white  "
          >
            {/* Image Section */}
            <div className="md:w-2/3 mb-4 md:mb-0">
              <img
                src={testimonial.image}
                alt={`${testimonial.name}`}
                className="w-full h-full object-cover scale-95 scale-y-90"
              />
            </div>

            {/* Quote and Details */}
            <div className="md:w-1/2 flex flex-col justify-center px-6">
              <div className="text-gray-800 font-serif leading-normal opacity-80  mb-4">
                <span className="text-3xl text-gray-500 leading-none">“</span>
                {testimonial.quote}
                <span className="text-3xl text-gray-500 leading-none">”</span>
              </div>
              <div className="mt-4">
                <p className="text-lg font-thin">{testimonial.name}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Critics;
